export type TBreakpointLabels = "mobile" | "tablet" | "desktop" | "all";

export type TBreakpoint = {
  [name in TBreakpointLabels]: {
    label?: string;
    icon: string;
    width?: number;
    deviceWidth?: number;
    deviceHeight?: number;
  };
};

export const BREAKPOINTS: TBreakpoint = {
  mobile: {
    icon: "phone_android",
    width: 600,
    deviceWidth: 375,
    deviceHeight: 667,
  },
  tablet: {
    icon: "tablet_android",
    width: 900,
    deviceWidth: 820,
    deviceHeight: 1180,
  },
  desktop: {
    icon: "computer",
    width: 1200,
    deviceWidth: 1024,
  },
  all: { icon: "tv" },
};
